
export const checkUrl = (url) => {
    let origin = window.location.origin;
    if (origin.includes("localhost")) {
        origin = "https://transcoder1.flowcenter.de"
    }
    let newUrl;
    if (url.startsWith("//")) {
        newUrl = url.replace("//", "/")
    }
    if (!url.includes(origin)) {
        newUrl = origin + newUrl;
    }
    console.log("LAMTEST newUrl", newUrl);
    return newUrl;
}